import { gql } from "@outschool/ui-apollo";

import ClassScheduleRequestFragment from "./ClassScheduleRequestFragment";

export const createClassScheduleRequestMutation = gql`
  mutation CreateClassScheduleRequest(
    $activityUid: ID!
    $timetable: TimetableInput!
    $timeZone: String!
    $message: String!
  ) {
    createClassScheduleRequest(
      activityUid: $activityUid
      timetable: $timetable
      timeZone: $timeZone
      message: $message
    ) {
      ...ClassScheduleRequestFragment
    }
  }
  ${ClassScheduleRequestFragment}
`;
